import { render } from "./SidebarCommon.vue?vue&type=template&id=0a7b58b2&ts=true"
import script from "./SidebarCommon.vue?vue&type=script&lang=ts"
export * from "./SidebarCommon.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__